import { render } from "./FinalCapitalPie.vue?vue&type=template&id=395bb1e7"
import script from "./FinalCapitalPie.vue?vue&type=script&lang=js"
export * from "./FinalCapitalPie.vue?vue&type=script&lang=js"

import exportComponent from "/home/artur/code/vue/zinzeszinsapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__